import { Flex, Text } from "@aws-amplify/ui-react";

export default function ContactAddressCardContent({address1, address2, city, state, zip}) {
  return (
    <Flex gap={3} direction="column">
      <Flex gap="45px" direction="row">
        <Flex gap={3} direction="column">
          <Text
            fontFamily="Inter"
            children={`Address1: ${address1 || ''}`}
          ></Text>
          <Text fontFamily="Inter" children={`City: ${city || ''}`}></Text>
        </Flex>
        <Flex gap={3} direction="column">
          <Text fontFamily="Inter" children={`Address2: ${address2 || ''}`}></Text>
          <Text fontFamily="Inter" children={`State: ${state || ''}`}></Text>
        </Flex>
      </Flex>
      <Flex gap="45px" direction="row">
        <Text fontFamily="Inter" children={`Zipcode: ${zip || ''}`}></Text>
      </Flex>
    </Flex>
  );
}
